import styled from 'styled-components';
import {SwiperButtonsDefaultBox} from './swiper-buttons.default.box';

export const SwiperButtonsCasino777Box = styled(SwiperButtonsDefaultBox)`
    right:.8rem;
`;